import script from "./UserRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegister.vue?vue&type=script&setup=true&lang=js"

import "./UserRegister.vue?vue&type=style&index=0&id=20cd90b5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20cd90b5"]])

export default __exports__